import React, { useState } from "react";
import { Award, Stethoscope, GraduationCap, CalendarCheck, Play } from "lucide-react";
import { doctor } from "../mock";
import { useBooking } from "../App";
import { Button } from "./ui/button";
import { Dialog, DialogContent } from "./ui/dialog";

export default function Doctor() {
  const { openBooking } = useBooking();
  const [videoOpen, setVideoOpen] = useState(false);
  return (
    <section id="medico" className="bg-[#f6f8fc]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="reveal">
            <span className="block text-xs font-semibold tracking-[0.2em] uppercase text-[#1d6fc0]">
              El Médico Oftalmólogo
            </span>
            <h2 className="font-display font-extrabold text-3xl lg:text-[2.6rem] leading-tight mt-4 text-[#0b2545]">
              {doctor.name}
            </h2>
            <div className="text-[#1d6fc0] font-semibold mt-2">{doctor.subspecialty}</div>
            <p className="text-slate-600 mt-5 leading-relaxed">{doctor.bio}</p>

            <blockquote className="mt-6 border-l-4 border-[#1d6fc0] pl-4 italic text-[#0b2545]">
              “{doctor.philosophy}”
            </blockquote>

            <div className="mt-7 space-y-3">
              {[
                { icon: Stethoscope, text: doctor.role },
                { icon: GraduationCap, text: `Egresado de la ${doctor.university}` },
                { icon: Award, text: doctor.position },
              ].map((it, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-9 h-9 shrink-0 rounded-lg bg-white border border-slate-200 grid place-items-center text-[#1d6fc0]">
                    <it.icon size={18} />
                  </div>
                  <span className="text-sm text-slate-700 pt-1.5">{it.text}</span>
                </div>
              ))}
            </div>

            <Button
              onClick={openBooking}
              className="mt-8 rounded-full bg-[#1d6fc0] hover:bg-[#175a9e] h-12 px-7 text-base font-semibold"
            >
              <CalendarCheck size={18} className="mr-2" /> Agenda hora con el especialista
            </Button>
          </div>

          <div className="reveal relative">
            <div className="absolute -inset-4 rounded-[32px] bg-gradient-to-br from-[#e8f2fd] to-transparent -z-0" />
            <div className="relative rounded-[28px] overflow-hidden shadow-2xl shadow-blue-950/20 border border-white">
              <img
                src={doctor.image}
                alt={doctor.name}
                className="w-full h-[520px] object-cover"
              />
              <button
                onClick={() => setVideoOpen(true)}
                aria-label="Ver presentación del doctor"
                className="absolute inset-0 grid place-items-center group/vid"
              >
                <span className="w-16 h-16 rounded-full bg-white/90 grid place-items-center shadow-xl group-hover/vid:scale-110 transition-transform">
                  <Play size={26} className="text-[#1d6fc0] ml-1 fill-[#1d6fc0]" />
                </span>
              </button>
              <div className="pointer-events-none absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#071a33]/85 to-transparent p-6">
                <div className="text-white font-display font-bold text-lg">{doctor.name}</div>
                <div className="text-blue-200 text-sm">{doctor.role}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={videoOpen} onOpenChange={setVideoOpen}>
        <DialogContent className="max-w-md p-0 overflow-hidden bg-[#071a33] border-none">
          <video
            src={doctor.video}
            poster={doctor.image}
            controls
            autoPlay
            playsInline
            className="w-full max-h-[80vh] bg-black"
          />
        </DialogContent>
      </Dialog>
    </section>
  );
}
